import {ConfigService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        config: null,
    },

    mutations: {
        saveConfig(state, config) {
            state.config = {...config};
        }
    },

    actions: {
        async getConfigAction({commit}) {
            await bindLoading(commit,
                async () => commit('saveConfig', await ConfigService.getAll()), 'config');
        },
        
        async updateConfigAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await ConfigService.update(item);
                    if (res.success) {
                        commit('saveConfig',item);
                    }
                    return res;
                }, 'config');
        },   

        async getConfig({commit}) {
            await bindLoading(commit,
                async () => commit('saveConfig', await ConfigService.getConfig()), 'config');
        },
          
        async setPassword({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await ConfigService.setPassword(item);
                    return res;
                }, 'config');
        }

    }

}